module.exports = "/static/media/lineto-circular-mediumItalic.f4494e11.eot";